module.exports = __webpack_public_path__ + "img/logo-poltekes2.200f280f.svg";